/*@ngInject*/
const yesNoFilter = function (localization) {
    let translations;

    localization.getTranslationByKey('filter.yesNo').then(function (result) {
        translations = result;
    });

    return function (text, length, end) {
        if (text) {
            return _.get(translations, 'yes');
        }
        return _.get(translations, 'no');
    };
};

angular.module('umCore')
    .filter('yesNoFilter', yesNoFilter);
